import { captureException } from '@sentry/react';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useUpdateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers } from '@/api/generated/endpoints/dashboard';
import type { ShareRequestSchema, ShareResponseSchema } from '@/api/generated/schemas';
import type { ErrorType } from '../mutators/IgniteAxiosClient';

type ShareUsersError = ErrorType<{ message?: string }>;
type ShareUsersMutationOptions = UseMutationOptions<
  ShareResponseSchema,
  ShareUsersError,
  { objectId: string; data: ShareRequestSchema }
>;

export function useShareUsersMutation(mutationOptions?: ShareUsersMutationOptions) {
  return useUpdateShareUsersV1Auth0ThoughtspotobjectsObjectIdShareusers({
    mutation: {
      ...mutationOptions,
      onError: (error, variables, onMutateResult, context) => {
        captureException(error, {
          level: 'error',
          tags: { feature: 'share', context: 'update-share-users' },
          extra: { message: 'Failed to update share users', objectId: variables.objectId },
        });
        mutationOptions?.onError?.(error, variables, onMutateResult, context);
      },
    },
  });
}
